import raw from './catalog.generated.json'

/**
 * The SDK / Python / SQL vocabulary the sources complete from. Generated by
 * `pnpm gen:code-intel` (scripts/gen-code-intel.ts) from the SDK's types,
 * papan_sandbox.py and papan.db's constants — never edit the JSON by hand.
 */
export interface CatalogMember {
  name: string
  kind: 'method' | 'property' | 'namespace'
  signature: string
  doc: string
  members?: CatalogMember[]
}

export interface CodeIntelCatalog {
  sdk: { namespace: CatalogMember[]; client: CatalogMember[] }
  python: CatalogMember[]
  sql: {
    context: Array<{ name: string; pii: boolean }>
    functions: string[]
    systemColumns: string[]
    verbs: string[]
  }
}

export const catalog = raw as CodeIntelCatalog

/** The member reached by walking `path` from `members`, or null. */
export function memberAt(members: CatalogMember[], path: string[]): CatalogMember | null {
  let level: CatalogMember[] | undefined = members
  let found: CatalogMember | null = null
  for (const name of path) {
    found = level?.find((m) => m.name === name) ?? null
    if (!found) return null
    level = found.members
  }
  return found
}
